import { DeliveryOptionsEnum, StockLocation, } from '@as-react/common-types';
export const getDeliveryExplanation = (deliveryPromise, deliveryPromiseExplanations) => {
    if (!!deliveryPromiseExplanations && !!deliveryPromise && deliveryPromise.stockLocation) {
        switch (deliveryPromise.stockLocation) {
            case StockLocation.STORE:
                return deliveryPromiseExplanations.storeStock;
            case StockLocation.WAREHOUSE:
                return deliveryPromiseExplanations.warehouseStock;
            case StockLocation.SUPPLIER:
                return deliveryPromiseExplanations.supplierStock;
            case StockLocation.PREORDER:
                return deliveryPromiseExplanations.preOrder;
            case StockLocation.POSTOUT:
                return deliveryPromiseExplanations.postOut;
            default:
                return;
        }
    }
    else {
        return;
    }
};
export const isDeliveryMessageCollectStoreOrHQ = (deliveryMessages) => !!(deliveryMessages === null || deliveryMessages === void 0 ? void 0 : deliveryMessages[DeliveryOptionsEnum.COLLECT_STORE]) || !!(deliveryMessages === null || deliveryMessages === void 0 ? void 0 : deliveryMessages[DeliveryOptionsEnum.COLLECT_HQ]);
export const isHomeDelivery = (option) => [DeliveryOptionsEnum.HOME_DELIVERY, DeliveryOptionsEnum.NAMED_DAY, DeliveryOptionsEnum.NEXT_DAY].includes(option);
